import {IonButton, IonCard, IonCardHeader, IonCol, IonInput, IonItem, IonRow} from "@ionic/react";
import {useEffect, useState} from "react";
import './DertigenMoveInput.css';
import createAxiosInstance from "../services/AxiosInstance";
import {useToast} from "../Utils/useToasts";
import {User} from "../model/User";
import {DertigenEvent} from "../model/DertigenEvent";


interface DertigenMoveInputProps {
    currentPlayer?: User;
    lobbyId?: number;
    throwForPlayerId?: number;
}

const DertigenMoveInput: React.FC<DertigenMoveInputProps> = ({currentPlayer, lobbyId, throwForPlayerId}) => {
    const [amountOfStripesForNextPlayer, setAmountOfStripesForNextPlayer] = useState<string>('');
    const [amountOfStripesForSelf, setAmountOfStripesForSelf] = useState<string>('');
    const [submitting, setSubmitting] = useState<boolean>(false);
    const axios = createAxiosInstance();
    const showToasts = useToast();

    const addStripesToSelf = (amountOfStripes: number) => {
        const move: DertigenEvent = {
            stripes: Number(amountOfStripes),
            gulps: 0,
            turnMove: true,
            thrownById: currentPlayer?.id
        }
        setSubmitting(true)
        axios.patch(`/lobbies/move/${lobbyId}/${currentPlayer?.id}`, move)
            .then(res => {
                setAmountOfStripesForNextPlayer('')
            }).catch(err => {
            if (err.response.status === 405) {
                showToasts('Je hebt geen toestemming', "danger")
            } else {
                showToasts('Er is iets mis gegaan', "danger")
            }
        }).finally(() => setSubmitting(false))
    }

    const doubler = () => {
        setSubmitting(true)
        axios.patch(`/lobbies/double/${lobbyId}/${currentPlayer?.id}`)
            .then(() => {
                showToasts("Je hebt de anderen verdubbeld!", "success")
            }).catch(err => {
            if (err.response.status === 405) {
                showToasts('Je hebt geen toestemming', "danger")
            } else {
                showToasts('Er is iets mis gegaan', "danger")
            }
        }).finally(() => setSubmitting(false))
    }

    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter' && (amountOfStripesForNextPlayer !== '' || amountOfStripesForSelf !== '')) {
            event.preventDefault()
            event.stopPropagation()

            if (amountOfStripesForNextPlayer !== '' && amountOfStripesForSelf !== '') {
                showToasts('Je kan niet voor jezelf gooien en voor de volgende speler', "danger")
                return
            } else if (amountOfStripesForNextPlayer !== '') {
                const move: DertigenEvent = {
                    stripes: Number(amountOfStripesForNextPlayer),
                    gulps: 0,
                    turnMove: true,
                    thrownById: currentPlayer?.id
                }
                setSubmitting(true)
                axios.patch(`/lobbies/move/${lobbyId}/${throwForPlayerId}`, move)
                    .then(res => {
                        setAmountOfStripesForNextPlayer('')
                        showToasts('Strepen toegevoegd!', "success")
                        event.target.blur()
                    }).catch(err => {
                    if (err.response.status === 405) {
                        showToasts('Je hebt geen toestemming', "danger")
                    } else {
                        showToasts('Er is iets mis gegaan', "danger")
                    }
                }).finally(() => setSubmitting(false))
            } else if (amountOfStripesForSelf !== '') {
                const move: DertigenEvent = {
                    stripes: Number(amountOfStripesForSelf),
                    gulps: 0,
                    turnMove: true,
                    thrownById: currentPlayer?.id
                }
                setSubmitting(true)
                axios.patch(`/lobbies/move/${lobbyId}/${currentPlayer?.id}`, move)
                    .then(() => {
                        setAmountOfStripesForSelf('')
                        showToasts('Strepen toegevoegd!', "success")
                        event.target.blur()
                    }).catch(err => {
                    if (err.response.status === 405) {
                        showToasts('Je hebt geen toestemming', "danger")
                    } else {
                        showToasts('Er is iets mis gegaan', "danger")
                    }
                }).finally(() => setSubmitting(false))
            } else {
                showToasts('Je moet een aantal strepen invullen', "danger")
            }
        }
    }

    const addStreet = () => {
        const move: DertigenEvent = {
            stripes: 50,
            gulps: 0,
            turnMove: true,
            thrownById: currentPlayer?.id
        }
        setSubmitting(true)
        axios.patch(`/lobbies/move/${lobbyId}/${throwForPlayerId}`, move)
            .then(res => {
                setAmountOfStripesForNextPlayer('')
                setAmountOfStripesForSelf('')
                showToasts('Straat gegooid!', "success")
            }).catch(err => {
            if (err.response.status === 405) {
                showToasts('Je hebt geen toestemming', "danger")
            } else {
                showToasts('Er is iets mis gegaan', "danger")
            }
        }).finally(() => setSubmitting(false))
    }


    useEffect(() => {
    }, []);

    return (
        <>
            <IonCard>
                <IonCardHeader>{currentPlayer?.name} is aan de beurt</IonCardHeader>
            </IonCard>
            <IonRow class='stripes-button-box'>
                <IonButton className='stripes-to-self' onClick={() => addStripesToSelf(5)} disabled={submitting}>+5 </IonButton>
                <IonButton className='stripes-to-self' onClick={() => addStripesToSelf(10)} disabled={submitting}>+10</IonButton>
                <IonButton className='stripes-to-self' onClick={() => addStripesToSelf(15)} disabled={submitting}>+15</IonButton>
                <IonButton className='stripes-to-self' onClick={() => addStripesToSelf(20)} disabled={submitting}>+20</IonButton>
            </IonRow>
            <IonRow class='special-button-box'>
                <IonButton className='others' onClick={() => doubler()} disabled={submitting}>X 2</IonButton>
                <IonButton className='others' onClick={() => addStreet()} disabled={submitting}>Straatje</IonButton>
            </IonRow>
            <div className={'input-container'}>
                <IonCol>
                    <IonItem className="input-for-self">
                        <IonInput
                            type="number"
                            value={amountOfStripesForSelf}
                            placeholder="Voor gooier"
                            onIonInput={e => setAmountOfStripesForSelf(e.detail.value!)}
                            onKeyDown={handleKeyDown}
                            enterkeyhint="done"
                            disabled={submitting}
                        />
                    </IonItem>
                </IonCol>
                <IonCol>
                    <IonItem className="input-for-next">
                        <IonInput
                            type="number"
                            value={amountOfStripesForNextPlayer}
                            placeholder="Volgende speler"
                            onIonInput={e => setAmountOfStripesForNextPlayer(e.detail.value!)}
                            onKeyDown={handleKeyDown}
                            enterkeyhint="done"
                            disabled={submitting}
                        />
                    </IonItem>
                </IonCol>
            </div>
        </>
    );
};

export default DertigenMoveInput;
